const config = {
  hexMap: {
    tile: {
      radius: 1,
      thickness: 0.12,
      // Top of water (and fogged) tiles: the bottom of the land tiles' bevel.
      waterThickness: 0.085,
    },
  },
};

export default config;
